module.exports = __webpack_public_path__ + "assets/0044a5e50e3c7c56017bdc71e9c677ff.png";